import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import DisputeManagementPage from './DisputeManagementPage';

const DisputeManagementRoute: React.FC = () => {
  const featureFlags = useModuleFeatureFlag('disputeManagement');

  return (
    <Switch>
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission path="/dispute-management">
        <DisputeManagementPage />
      </ProtectedRoute>
    </Switch>
  );
};

export default DisputeManagementRoute;
